import './main.scss';

import '@popperjs/core';
import Dropdown from 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';

import './utils/datatable';

document.addEventListener('DOMContentLoaded', (): void => {
  // Init dropdown
  const dropdownElementList: Element[] = Array.from(document.querySelectorAll('.dropdown-toggle'));
  dropdownElementList.map((dropdownToggleEl: Element) => {
    return new Dropdown(dropdownToggleEl);
  });
});
